import React from 'react'
import styled from 'styled-components'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'

import {BoxedContainer, Section} from '../../elements'

const TwoColumnSection = ({
  children,
  backgroundColor,
  color,
  reverse,
  backgroundImage,
}) => (
  <Section
    backgroundColor={backgroundColor}
    padding="both"
    style={{
      color: color,
      position: 'relative',
    }}
  >
    <BoxedContainer
      medium
      style={{
        position: 'relative',
        zIndex: '1',
      }}
    >
      <Columns reverse={reverse}>{children}</Columns>
    </BoxedContainer>
    {backgroundImage && (
      <GatsbyImage
        image={getImage(backgroundImage)}
        style={{
          position: 'absolute',
          top: '0',
          width: '100%',
          height: '100%',
          zIndex: '0',
        }}
      />
    )}
  </Section>
)

export default TwoColumnSection

const Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 40px;

  @media (min-width: ${p => p.theme.breakpoints.md}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${p => p.theme.breakpoints.lg}) {
    grid-template-columns: ${p => (p.reverse ? '1.2fr 0.8fr' : '0.8fr 1.2fr')};
  }

  @media (min-width: ${p => p.theme.breakpoints.xl}) {
    gap: 60px;
  }
`
